import { graphql } from 'gatsby';
import React from 'react';

import {
  Drupal_FieldParagraphNineteenFooterFieldAdditionalResources,
  Drupal_FieldParagraphNineteenFooterFieldNineteenCtas,
  Drupal_ParagraphNineteenFooter
} from '../../../generated/graphql';
import Link from '../../link/link';
import NineteenCta, { nineteenCtaThemes } from '../nineteen-cta/nineteen-cta';
import './nineteen-footer.scss';
import { Heading } from 'lucid-components-react';

interface Props {
  entity: Drupal_ParagraphNineteenFooter;
}

const NineteenFooter = ({
  entity: { fieldHeader, fieldAdditionalResources, fieldNineteenCtas }
}: Props) => (
  <footer className="nineteen-footer">
    <div className="lucid-container nineteen-footer__wrapper">
      <div className="nineteen-footer__blurb">
        <Heading as="h2" variant="subheadS" color="white" mt={0}>
          {fieldHeader}
        </Heading>
        {(fieldNineteenCtas as Drupal_FieldParagraphNineteenFooterFieldNineteenCtas[]).map(
          ({ entity }, index) => (
            <NineteenCta
              primary={index === 0}
              theme={nineteenCtaThemes.retro}
              key={entity!.entityId!}
              entity={entity!}
            />
          )
        )}
      </div>
      <div className="nineteen-footer__resources">
        <p className="nineteen-footer__resource-header">
          Additional resources:
        </p>
        <ul className="nineteen-footer__resource-list">
          {(fieldAdditionalResources as Drupal_FieldParagraphNineteenFooterFieldAdditionalResources[]).map(
            ({ url, title }) => (
              <li key={title!} className="nineteen-footer__resource-item">
                <Link
                  inverse
                  className="nineteen-footer__resource-link"
                  to={url!.path!}
                >
                  {title}
                </Link>
              </li>
            )
          )}
        </ul>
      </div>
    </div>
  </footer>
);

export default NineteenFooter;

export const query = graphql`
  fragment nineteenFooter on Drupal_ParagraphNineteenFooter {
    fieldHeader
    fieldAdditionalResources {
      url {
        path
      }
      title
    }
    fieldNineteenCtas {
      entity {
        ...nineteenCta
      }
    }
  }
`;
